var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewAndConfirmation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 11.292C9.10658 11.292 11.625 8.77358 11.625 5.66699C11.625 2.56039 9.10658 0.0419922 6 0.0419922C2.8934 0.0419922 0.375 2.56039 0.375 5.66699C0.375 8.77358 2.8934 11.292 6 11.292ZM8.9184 4.49449C9.11809 4.29479 9.11809 3.97101 8.9184 3.77131C8.71872 3.57161 8.39492 3.57161 8.19523 3.77131L5.48864 6.47791L4.31614 5.30541C4.11643 5.10572 3.79266 5.10572 3.59296 5.30541C3.39326 5.50509 3.39326 5.82889 3.59296 6.02858L5.12705 7.56267C5.32674 7.76236 5.65053 7.76236 5.85022 7.56267L8.9184 4.49449Z",
    fill: "#9FA0A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewAndConfirmation);
export default __webpack_public_path__ + "static/media/review-and-confirmation.38d60fe90c335015fa6bd3609e990f70.svg";
export { ForwardRef as ReactComponent };